/* eslint no-template-curly-in-string: 0 */
import jetblueLogo from '../../assets/images/true-blue-blue-on-white.jpg';
// import { FLOW_TYPES } from "../../utils/enums";

export const jetblueTravelBank = {
  id: "JETBLUE_TRAVEL_BANK",
  displayName: "JetBlue Travel Bank",
  paywall: {
    tile: {
      displayName: "JetBlue Travel Bank",
      tagline: ["Receive a 25% bonus"],
      description: [
        {
          string: "Available in your JetBlue Travel Bank",
          type: "div",
        },
        {
          string: "account within 3 business days",
          type: "div"
        }
      ],
      // btnLabel: "Next",
      logo: jetblueLogo
    }
  },
  // recipientLogin: {
  //   flow: FLOW_TYPES.RECIPIENT_LOGIN.FORM,
  //   form: {
  //     title: "JetBlue Travel Credit",
  //     description: "Please enter the following information to receive your payment.",
  //     jsonFormProps: {
  //       schema: {
  //         type: "object",
  //         required: ["createTrueBlueAccount"],
  //         properties: {
  //           createTrueBlueAccount: {
  //             type: "boolean",
  //             title: "Do you have an existing TrueBlue account?",
  //             default: true,
  //             enumNames: [
  //               "No, please create one for me.",
  //               "Yes, I have an existing account number."
  //             ]
  //           }
  //         },
  //         dependencies: {
  //           createTrueBlueAccount: {
  //             oneOf: [
  //               {
  //                 required: ["emailAddress"],
  //                 properties: {
  //                   emailAddress: {
  //                     type: "string",
  //                     title:
  //                       "Email address to associate with your new TrueBlue account",
  //                     format: "email"
  //                   },
  //                   createTrueBlueAccount: { enum: [true] }
  //                 }
  //               },
  //               {
  //                 required: ["emailAddress", "trueBlueNumber"],
  //                 properties: {
  //                   emailAddress: {
  //                     type: "string",
  //                     title: "TrueBlue Email Address",
  //                     format: "email"
  //                   },
  //                   trueBlueNumber: {
  //                     type: "string",
  //                     title: "TrueBlue Account Number",
  //                     pattern: "^\\d*$",
  //                     maxLength: 10,
  //                     minLength: 10
  //                   },
  //                   createTrueBlueAccount: { enum: [false] }
  //                 }
  //               }
  //             ]
  //           }
  //         }
  //       },
  //       formData: { emailAddress: "${payment.recipientEmail}" },
  //       uiSchema: {
  //         emailAddress: {
  //           "ui:widget": "email",
  //           classNames: "json-form-field"
  //         },
  //         trueBlueNumber: { classNames: "json-form-field" },
  //         createTrueBlueAccount: {
  //           "ui:widget": "radio",
  //           classNames: "json-form-field"
  //         }
  //       }
  //     },
  //     validationErrors: {
  //       trueBlueNumber: {
  //         type: "TrueBlue Account Numbers should be 10 numeric digits",
  //         pattern: "TrueBlue Account Numbers should be 10 numeric digits",
  //         maxLength: "TrueBlue Account Numbers should be 10 numeric digits",
  //         minLength: "TrueBlue Account Numbers should be 10 numeric digits",
  //         required: "TrueBlue Account Number is required",
  //         format: "TrueBlue Account Numbers should be 10 numeric digits",
  //       },
  //       emailAddress: {
  //         type: "Invalid email",
  //         pattern: "Invalid email",
  //         format: "Invalid email",
  //         required: "Email address is required"
  //       }
  //     },
  //     filterFieldsByValue: [
  //       {
  //         expectedValues: { createAccount: true },
  //         fieldsToInclude: ["createTrueBlueAccount", "emailAddress"]
  //       },
  //       {
  //         expectedValues: { createAccount: false },
  //         fieldsToInclude: [
  //           "createTrueBlueAccount",
  //           "emailAddress",
  //           "trueBlueNumber"
  //         ]
  //       }
  //     ]
  //   }
  // },
  acceptPayment: {
    description: [
      "You have chosen to receive ",
      {
        string: "${payment.amount}",
        props: {
          className: 'payment-amount'
        },
        transformations: [
          {
            "type": "removeCurrencyFormatting"
          },
          {
            "type": "multiply",
            "config": {
              "multiplier": 1.25
            }
          },
          {
            "type": "ceil"
          },
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ]
      },
      " (",
      {
        string: "${payment.amount}",
        transformations: [
          {
            "type": "removeCurrencyFormatting"
          },
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ]
      },
      " plus the 25% bonus) to your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork'
        }
      },
      " account."
    ],
    imgSrc: jetblueLogo
  },
  paymentComplete: {
    imgSrc: jetblueLogo,
    initial: {
      description: [
        "Success! We sent ",
        {
          string: "${payment.acceptedAmount}",
          props: {
            className: 'payment-amount'
          },
          transformations: [
            {
              "type": "removeCurrencyFormatting"
            },
            {
              "type": "multiply",
              "config": {
                "multiplier": 1.25
              }
            },
            {
              "type": "ceil"
            },
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ]
        },
        " (",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              "type": "removeCurrencyFormatting"
            },
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ]
        },
        " plus the 25% bonus) to your ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " account."
      ],
    },
    revisit: {
      description: [
        "We sent ",
        {
          string: "${payment.acceptedAmount}",
          props: {
            className: 'payment-amount'
          },
          transformations: [
            {
              "type": "removeCurrencyFormatting"
            },
            {
              "type": "multiply",
              "config": {
                "multiplier": 1.25
              }
            },
            {
              "type": "ceil"
            },
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ]
        },
        " (",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              "type": "removeCurrencyFormatting"
            },
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ]
        },
        " plus the 25% bonus) to your ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " account."
      ],
    },
  },
  onHold: {
    imgSrc: jetblueLogo,
  }
};

export default jetblueTravelBank;
